import { useSelector } from 'react-redux';

import {
  CALL_BETS,
  DISCONNECTED,
  GAME_RESULT,
  CANCEL_ROUND,
  INSURANCE_CALLS,
  LAST_BETS, LOADING,
  NO_MORE_BETS,
  PLACE_YOUR_BETS,
  RECONNECTING,
  TABLE_CLOSED,
  WAIT_FOR_NEXT_GAME,
  WAIT_FOR_NEXT_ROUND,
  WAIT_FOR_RESULTS,
  CALL_BETS_DECISION,
  RACE_START_TIMER,
} from '@ezugi/constants';
import { RoundStatus } from '@ezugi/types/src/round';

import { roundStatusSelector } from '../store/selectors';
import { RootState } from '../store/types';
import { useIntl } from './useIntl';

const keys: Record<RoundStatus, string> = {
  [CANCEL_ROUND]: 'game_status.round_cancelled',
  [DISCONNECTED]: 'game_status.disconnected',
  [GAME_RESULT]: 'game_status.game_result',
  [LAST_BETS]: 'game_status.last_bets',
  [LOADING]: 'game_status.loading',
  [NO_MORE_BETS]: 'game_status.no_more_bets',
  [WAIT_FOR_NEXT_GAME]: 'game_status.wait_for_next_game',
  [WAIT_FOR_NEXT_ROUND]: 'game_status.wait_for_next_round',
  [WAIT_FOR_RESULTS]: 'game_status.wait_for_results',
  [PLACE_YOUR_BETS]: 'game_status.place_your_bets',
  [RECONNECTING]: 'game_status.reconnecting',
  [TABLE_CLOSED]: 'game_status.table_closed',
  [CALL_BETS]: 'game_status.call_bets',
  [INSURANCE_CALLS]: 'game_status.insurance',
  [CALL_BETS_DECISION]: 'game_status.call_bets_decision',
  [RACE_START_TIMER]: 'game_status.race_start_timer',
};

export function useRoundStatus() {
  const locales = useIntl({ keys });

  const roundStatus = useSelector<RootState, RoundStatus>(roundStatusSelector);

  return {
    raw: roundStatus,
    localized: locales[roundStatus],
    locales,
  };
}
